export default __webpack_public_path__ + "static/media/gmeet_image.3b2b6098.png";